export default __webpack_public_path__ + "static/media/Header-3.97e0c02c.jpg";